<template>
  <div class="page-shell">
    <section class="container auth-container">
      <div class="page-intro">
        <p class="eyebrow">Reset Password</p>
        <h1 class="page-title">通过短信验证码重置密码</h1>
      </div>

      <form class="panel auth-panel" @submit.prevent="handleSubmit">
        <div v-if="errorMessage" class="status-card is-error">{{ errorMessage }}</div>
        <div v-if="successMessage" class="status-card">{{ successMessage }}</div>

        <div class="form-grid">
          <label class="form-field form-field--full">
            <span class="form-label">手机号</span>
            <input v-model.trim="form.mobile" type="tel" placeholder="请输入手机号">
          </label>

          <label class="form-field form-field--full">
            <span class="form-label">短信验证码</span>
            <div class="inline-field">
              <input v-model.trim="form.code" type="text" placeholder="请输入验证码">
              <button
                class="btn btn--secondary inline-field__button"
                type="button"
                :disabled="sendingCode || countdown > 0"
                @click="handleSendCode"
              >
                {{ countdown > 0 ? `${countdown}s` : (sendingCode ? '发送中...' : '发送验证码') }}
              </button>
            </div>
          </label>

          <label class="form-field form-field--full">
            <span class="form-label">新密码</span>
            <input v-model.trim="form.password" type="password" placeholder="请输入新密码">
          </label>

          <label class="form-field form-field--full">
            <span class="form-label">确认新密码</span>
            <input
              v-model.trim="form.password_confirm"
              type="password"
              placeholder="请再次输入新密码"
            >
          </label>
        </div>

        <div class="auth-actions">
          <button class="btn btn--primary" type="submit" :disabled="submitting">
            {{ submitting ? '提交中...' : '重置密码' }}
          </button>
          <router-link class="btn btn--ghost" :to="{ name: 'login' }">返回登录</router-link>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import { resetMemberPassword, sendAuthCode } from '@/api/auth'

export default {
  name: 'ResetPasswordView',
  data() {
    return {
      submitting: false,
      sendingCode: false,
      countdown: 0,
      timerId: null,
      errorMessage: '',
      successMessage: '',
      form: {
        mobile: '',
        code: '',
        password: '',
        password_confirm: ''
      }
    }
  },
  beforeDestroy() {
    this.stopCountdown()
  },
  methods: {
    startCountdown(seconds) {
      this.stopCountdown()
      this.countdown = seconds

      this.timerId = window.setInterval(() => {
        if (this.countdown <= 1) {
          this.stopCountdown()
          return
        }

        this.countdown -= 1
      }, 1000)
    },
    stopCountdown() {
      if (this.timerId) {
        window.clearInterval(this.timerId)
        this.timerId = null
      }

      this.countdown = 0
    },
    async handleSendCode() {
      if (!this.form.mobile) {
        this.errorMessage = '请先填写手机号。'
        return
      }

      this.sendingCode = true
      this.errorMessage = ''
      this.successMessage = ''

      try {
        const response = await sendAuthCode({
          mobile: this.form.mobile,
          scene: 'reset_password'
        })

        this.successMessage = '验证码已发送，请注意查收。'
        this.startCountdown(Math.min(Number(response.expire_seconds) || 60, 60))
      } catch (error) {
        this.errorMessage = error.message || '验证码发送失败'
      } finally {
        this.sendingCode = false
      }
    },
    async handleSubmit() {
      if (!this.form.mobile || !this.form.code || !this.form.password || !this.form.password_confirm) {
        this.errorMessage = '请完整填写重置信息。'
        return
      }

      if (this.form.password !== this.form.password_confirm) {
        this.errorMessage = '两次输入的密码不一致。'
        return
      }

      this.submitting = true
      this.errorMessage = ''
      this.successMessage = ''

      try {
        await resetMemberPassword({
          ...this.form
        })

        this.successMessage = '密码已重置，请使用新密码登录。'
        this.$router.push({
          name: 'login',
          query: {
            mobile: this.form.mobile
          }
        })
      } catch (error) {
        this.errorMessage = error.message || '密码重置失败'
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.auth-container {
  max-width: 620px;
}

.auth-panel {
  display: grid;
  gap: 18px;
  padding: 24px;
}

.inline-field {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px;
}

.inline-field__button {
  min-width: 132px;
}

.auth-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

@media (max-width: 640px) {
  .auth-panel {
    padding: 20px;
  }

  .inline-field {
    grid-template-columns: 1fr;
  }
}
</style>
